import { render, staticRenderFns } from "./edit-delete-item-modal.vue?vue&type=template&id=3389c0ea&"
import script from "./edit-delete-item-modal.vue?vue&type=script&lang=js&"
export * from "./edit-delete-item-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-delete-item-modal.vue?vue&type=style&index=0&id=3389c0ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports